import React, { useEffect } from "react"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbParagraph from "../ui-kit/dfb_paragraph"
import DfbButton from "../ui-kit/dfb_button"
import CEpaperCard from "../elements/c_epaper_card"
import DfbCard from "../elements/dfb_card"
import CFilterEnhanced from "../elements/c_filter_enhanced"
import Section from "./section"

// Default layout is three columns = 0
const LAYOUT_TWO_COLUMNS = 1

const MCardGrid = ({
  data,
  collectionForPage,
  hasNextPage,
  totalCount,
  availableFilterOptions,
  setSelectedFilterOptions,
  handleNextPage,
}) => {
  const { uid, headline, text } = data

  const cardExtraClass =
    data.layout !== LAYOUT_TWO_COLUMNS ? "c-CardGrid-cardFour" : ""

  useEffect(() => {
    if (window.upgradeAllBehaviours) {
      // Init UI-kit for new cards
      window.upgradeAllBehaviours()
    }
  }, [collectionForPage])

  return (
    <Section
      baseClass="m-CardGrid"
      className={availableFilterOptions ? "m-CardGrid--filtered" : undefined}
      defaultBgColor={"grey"}
      defaultPadding="large"
      data={data}
    >
      <div className="m-CardGrid-wrapper">
        <div className="m-CardGrid-container">
          <div className="c-Headline m-CardGrid-headline">
            <DfbHeadline
              headline={headline}
              headline_level="h3"
              add_class="c-Headline-strokeLine"
            />
          </div>
          {text && (
            <DfbParagraph text={text} add_class="m-CardGrid-paragraph" />
          )}

          <CFilterEnhanced
            uid={uid}
            totalCount={totalCount}
            availableFilterOptions={availableFilterOptions}
            setSelectedFilterOptions={setSelectedFilterOptions}
          />
        </div>
        <div className="c-CardGrid m-CardGrid-cards">
          <div className="c-CardGrid-container">
            {collectionForPage &&
              collectionForPage.map((item) => (
                <div
                  key={item.uid + item.name}
                  className={`c-CardGrid-card ${cardExtraClass}`}
                >
                  {item.type === "epaper" ? (
                    <CEpaperCard
                      data={Object.assign(item, {
                        add_class: "dfb-Card--cover",
                      })}
                    />
                  ) : (
                    <DfbCard
                      data={Object.assign(item, {
                        add_class: "dfb-Card--cover",
                      })}
                    />
                  )}
                </div>
              ))}
          </div>
        </div>
      </div>
      {hasNextPage && (
        <div className="m-CardGrid-buttonContainer">
          <DfbButton
            onClick={() => {
              handleNextPage()
            }}
            text="Mehr laden"
            tagName="button"
            add_class="m-CardGrid-button"
          />
        </div>
      )}
    </Section>
  )
}

export default MCardGrid
